/**
 * National phone format masks by ISO2 (from react-phone-input-2).
 * `.` = digit placeholder; mask includes country calling code digits.
 */
const PHONE_FORMATS_BY_ISO = {
  "af": { "format": null, "maxNationalDigits": 13 },
  "al": { "format": null, "maxNationalDigits": 12 },
  "dz": { "format": null, "maxNationalDigits": 12 },
  "as": { "format": null, "maxNationalDigits": 11 },
  "ad": { "format": null, "maxNationalDigits": 12 },
  "ao": { "format": null, "maxNationalDigits": 12 },
  "ai": { "format": null, "maxNationalDigits": 11 },
  "ag": { "format": null, "maxNationalDigits": 11 },
  "ar": { "format": "+.. (..) ........", "maxNationalDigits": 10 },
  "am": { "format": null, "maxNationalDigits": 12 },
  "aw": { "format": null, "maxNationalDigits": 12 },
  "au": { "format": "+.. ... ... ...", "maxNationalDigits": 9 },
  "at": { "format": null, "maxNationalDigits": 13 },
  "az": { "format": null, "maxNationalDigits": 12 },
  "bs": { "format": null, "maxNationalDigits": 11 },
  "bh": { "format": null, "maxNationalDigits": 12 },
  "bd": { "format": null, "maxNationalDigits": 12 },
  "bb": { "format": null, "maxNationalDigits": 11 },
  "by": { "format": "+... (..) ... .. ..", "maxNationalDigits": 9 },
  "be": { "format": "+.. ... .. .. ..", "maxNationalDigits": 9 },
  "bz": { "format": null, "maxNationalDigits": 12 },
  "bj": { "format": null, "maxNationalDigits": 12 },
  "bm": { "format": null, "maxNationalDigits": 11 },
  "bt": { "format": null, "maxNationalDigits": 12 },
  "bo": { "format": null, "maxNationalDigits": 12 },
  "ba": { "format": null, "maxNationalDigits": 12 },
  "bw": { "format": null, "maxNationalDigits": 12 },
  "br": { "format": "+.. (..) .........", "maxNationalDigits": 11 },
  "io": { "format": null, "maxNationalDigits": 12 },
  "vg": { "format": null, "maxNationalDigits": 11 },
  "bn": { "format": null, "maxNationalDigits": 12 },
  "bg": { "format": null, "maxNationalDigits": 12 },
  "bf": { "format": null, "maxNationalDigits": 12 },
  "bi": { "format": null, "maxNationalDigits": 12 },
  "kh": { "format": null, "maxNationalDigits": 12 },
  "cm": { "format": null, "maxNationalDigits": 12 },
  "ca": { "format": "+. (...) ...-....", "maxNationalDigits": 10 },
  "cv": { "format": null, "maxNationalDigits": 12 },
  "bq": { "format": "", "maxNationalDigits": 12 },
  "ky": { "format": null, "maxNationalDigits": 11 },
  "cf": { "format": null, "maxNationalDigits": 12 },
  "td": { "format": null, "maxNationalDigits": 12 },
  "cl": { "format": null, "maxNationalDigits": 13 },
  "cn": { "format": "+.. ..-.........", "maxNationalDigits": 11 },
  "co": { "format": null, "maxNationalDigits": 13 },
  "km": { "format": null, "maxNationalDigits": 12 },
  "cd": { "format": null, "maxNationalDigits": 12 },
  "cg": { "format": null, "maxNationalDigits": 12 },
  "ck": { "format": null, "maxNationalDigits": 12 },
  "cr": { "format": "+... ....-....", "maxNationalDigits": 8 },
  "ci": { "format": null, "maxNationalDigits": 12 },
  "hr": { "format": null, "maxNationalDigits": 12 },
  "cu": { "format": null, "maxNationalDigits": 13 },
  "cw": { "format": "", "maxNationalDigits": 12 },
  "cy": { "format": "+... .. ......", "maxNationalDigits": 8 },
  "cz": { "format": null, "maxNationalDigits": 12 },
  "dk": { "format": "+.. .. .. .. ..", "maxNationalDigits": 8 },
  "dj": { "format": null, "maxNationalDigits": 12 },
  "dm": { "format": null, "maxNationalDigits": 11 },
  "do": { "format": "", "maxNationalDigits": 14 },
  "ec": { "format": null, "maxNationalDigits": 12 },
  "eg": { "format": null, "maxNationalDigits": 13 },
  "sv": { "format": "+... ....-....", "maxNationalDigits": 8 },
  "gq": { "format": null, "maxNationalDigits": 12 },
  "er": { "format": null, "maxNationalDigits": 12 },
  "ee": { "format": "+... .... ......", "maxNationalDigits": 10 },
  "et": { "format": null, "maxNationalDigits": 12 },
  "fk": { "format": null, "maxNationalDigits": 12 },
  "fo": { "format": null, "maxNationalDigits": 12 },
  "fj": { "format": null, "maxNationalDigits": 12 },
  "fi": { "format": "+... .. ... .. ..", "maxNationalDigits": 9 },
  "fr": { "format": "+.. . .. .. .. ..", "maxNationalDigits": 9 },
  "gf": { "format": null, "maxNationalDigits": 12 },
  "pf": { "format": null, "maxNationalDigits": 12 },
  "ga": { "format": null, "maxNationalDigits": 12 },
  "gm": { "format": null, "maxNationalDigits": 12 },
  "ge": { "format": null, "maxNationalDigits": 12 },
  "de": { "format": "+.. .... ........", "maxNationalDigits": 12 },
  "gh": { "format": null, "maxNationalDigits": 12 },
  "gi": { "format": null, "maxNationalDigits": 12 },
  "gr": { "format": null, "maxNationalDigits": 13 },
  "gl": { "format": null, "maxNationalDigits": 12 },
  "gd": { "format": null, "maxNationalDigits": 11 },
  "gp": { "format": "", "maxNationalDigits": 12 },
  "gu": { "format": null, "maxNationalDigits": 11 },
  "gt": { "format": "+... ....-....", "maxNationalDigits": 8 },
  "gn": { "format": null, "maxNationalDigits": 12 },
  "gw": { "format": null, "maxNationalDigits": 12 },
  "gy": { "format": null, "maxNationalDigits": 12 },
  "ht": { "format": "+... ....-....", "maxNationalDigits": 8 },
  "hn": { "format": null, "maxNationalDigits": 12 },
  "hk": { "format": "+... .... ....", "maxNationalDigits": 8 },
  "hu": { "format": null, "maxNationalDigits": 13 },
  "is": { "format": "+... ... ....", "maxNationalDigits": 7 },
  "in": { "format": "+.. .....-.....", "maxNationalDigits": 10 },
  "id": { "format": null, "maxNationalDigits": 13 },
  "ir": { "format": null, "maxNationalDigits": 13 },
  "iq": { "format": null, "maxNationalDigits": 12 },
  "ie": { "format": "+... .. .......", "maxNationalDigits": 9 },
  "il": { "format": "+... ... ... ....", "maxNationalDigits": 10 },
  "it": { "format": "+.. ... .......", "maxNationalDigits": 10 },
  "jm": { "format": null, "maxNationalDigits": 11 },
  "jp": { "format": "+.. .. .... ....", "maxNationalDigits": 10 },
  "jo": { "format": null, "maxNationalDigits": 12 },
  "kz": { "format": "+. ... ...-..-..", "maxNationalDigits": 10 },
  "ke": { "format": null, "maxNationalDigits": 12 },
  "ki": { "format": null, "maxNationalDigits": 12 },
  "kw": { "format": null, "maxNationalDigits": 12 },
  "kg": { "format": null, "maxNationalDigits": 12 },
  "la": { "format": null, "maxNationalDigits": 12 },
  "lv": { "format": null, "maxNationalDigits": 12 },
  "lb": { "format": null, "maxNationalDigits": 12 },
  "ls": { "format": null, "maxNationalDigits": 12 },
  "lr": { "format": null, "maxNationalDigits": 12 },
  "ly": { "format": null, "maxNationalDigits": 12 },
  "li": { "format": null, "maxNationalDigits": 12 },
  "lt": { "format": null, "maxNationalDigits": 12 },
  "lu": { "format": null, "maxNationalDigits": 12 },
  "mo": { "format": null, "maxNationalDigits": 12 },
  "mk": { "format": null, "maxNationalDigits": 12 },
  "mg": { "format": null, "maxNationalDigits": 12 },
  "mw": { "format": null, "maxNationalDigits": 12 },
  "my": { "format": "+.. ..-....-....", "maxNationalDigits": 10 },
  "mv": { "format": null, "maxNationalDigits": 12 },
  "ml": { "format": null, "maxNationalDigits": 12 },
  "mt": { "format": null, "maxNationalDigits": 12 },
  "mh": { "format": null, "maxNationalDigits": 12 },
  "mq": { "format": null, "maxNationalDigits": 12 },
  "mr": { "format": null, "maxNationalDigits": 12 },
  "mu": { "format": null, "maxNationalDigits": 12 },
  "mx": { "format": null, "maxNationalDigits": 13 },
  "fm": { "format": null, "maxNationalDigits": 12 },
  "md": { "format": "+... (..) ..-..-..", "maxNationalDigits": 8 },
  "mc": { "format": null, "maxNationalDigits": 12 },
  "mn": { "format": null, "maxNationalDigits": 12 },
  "me": { "format": null, "maxNationalDigits": 12 },
  "ms": { "format": null, "maxNationalDigits": 11 },
  "ma": { "format": null, "maxNationalDigits": 12 },
  "mz": { "format": null, "maxNationalDigits": 12 },
  "mm": { "format": null, "maxNationalDigits": 13 },
  "na": { "format": null, "maxNationalDigits": 12 },
  "nr": { "format": null, "maxNationalDigits": 12 },
  "np": { "format": null, "maxNationalDigits": 12 },
  "nl": { "format": "+.. .. ........", "maxNationalDigits": 10 },
  "nc": { "format": null, "maxNationalDigits": 12 },
  "nz": { "format": "+.. ...-...-....", "maxNationalDigits": 10 },
  "ni": { "format": null, "maxNationalDigits": 12 },
  "ne": { "format": null, "maxNationalDigits": 12 },
  "ng": { "format": null, "maxNationalDigits": 12 },
  "nu": { "format": null, "maxNationalDigits": 12 },
  "nf": { "format": null, "maxNationalDigits": 12 },
  "kp": { "format": null, "maxNationalDigits": 12 },
  "mp": { "format": null, "maxNationalDigits": 11 },
  "no": { "format": "+.. ... .. ...", "maxNationalDigits": 8 },
  "om": { "format": null, "maxNationalDigits": 12 },
  "pk": { "format": "+.. ...-.......", "maxNationalDigits": 10 },
  "pw": { "format": null, "maxNationalDigits": 12 },
  "ps": { "format": null, "maxNationalDigits": 12 },
  "pa": { "format": null, "maxNationalDigits": 12 },
  "pg": { "format": null, "maxNationalDigits": 12 },
  "py": { "format": null, "maxNationalDigits": 12 },
  "pe": { "format": null, "maxNationalDigits": 13 },
  "ph": { "format": "+.. .... .......", "maxNationalDigits": 11 },
  "pl": { "format": "+.. ...-...-...", "maxNationalDigits": 9 },
  "pt": { "format": null, "maxNationalDigits": 12 },
  "pr": { "format": "", "maxNationalDigits": 14 },
  "qa": { "format": null, "maxNationalDigits": 12 },
  "re": { "format": null, "maxNationalDigits": 12 },
  "ro": { "format": null, "maxNationalDigits": 13 },
  "ru": { "format": "+. (...) ...-..-..", "maxNationalDigits": 10 },
  "rw": { "format": null, "maxNationalDigits": 12 },
  "bl": { "format": "", "maxNationalDigits": 12 },
  "sh": { "format": null, "maxNationalDigits": 12 },
  "kn": { "format": null, "maxNationalDigits": 11 },
  "lc": { "format": null, "maxNationalDigits": 11 },
  "mf": { "format": "", "maxNationalDigits": 12 },
  "pm": { "format": null, "maxNationalDigits": 12 },
  "vc": { "format": null, "maxNationalDigits": 11 },
  "ws": { "format": null, "maxNationalDigits": 12 },
  "sm": { "format": null, "maxNationalDigits": 12 },
  "st": { "format": null, "maxNationalDigits": 12 },
  "sa": { "format": null, "maxNationalDigits": 12 },
  "sn": { "format": null, "maxNationalDigits": 12 },
  "rs": { "format": null, "maxNationalDigits": 12 },
  "sc": { "format": null, "maxNationalDigits": 12 },
  "sl": { "format": null, "maxNationalDigits": 12 },
  "sg": { "format": "+.. ....-....", "maxNationalDigits": 8 },
  "sx": { "format": null, "maxNationalDigits": 11 },
  "sk": { "format": null, "maxNationalDigits": 12 },
  "si": { "format": null, "maxNationalDigits": 12 },
  "sb": { "format": null, "maxNationalDigits": 12 },
  "so": { "format": null, "maxNationalDigits": 12 },
  "za": { "format": null, "maxNationalDigits": 13 },
  "kr": { "format": "+.. ... .... ....", "maxNationalDigits": 11 },
  "ss": { "format": null, "maxNationalDigits": 12 },
  "es": { "format": "+.. ... ... ...", "maxNationalDigits": 9 },
  "lk": { "format": null, "maxNationalDigits": 13 },
  "sd": { "format": null, "maxNationalDigits": 12 },
  "sr": { "format": null, "maxNationalDigits": 12 },
  "sz": { "format": null, "maxNationalDigits": 12 },
  "se": { "format": "+.. (...) ...-...", "maxNationalDigits": 9 },
  "ch": { "format": "+.. .. ... .. ..", "maxNationalDigits": 9 },
  "sy": { "format": null, "maxNationalDigits": 12 },
  "tw": { "format": null, "maxNationalDigits": 12 },
  "tj": { "format": null, "maxNationalDigits": 12 },
  "tz": { "format": null, "maxNationalDigits": 12 },
  "th": { "format": null, "maxNationalDigits": 13 },
  "tl": { "format": null, "maxNationalDigits": 12 },
  "tg": { "format": null, "maxNationalDigits": 12 },
  "tk": { "format": null, "maxNationalDigits": 12 },
  "to": { "format": null, "maxNationalDigits": 12 },
  "tt": { "format": null, "maxNationalDigits": 11 },
  "tn": { "format": null, "maxNationalDigits": 12 },
  "tr": { "format": "+.. ... ... .. ..", "maxNationalDigits": 10 },
  "tm": { "format": null, "maxNationalDigits": 12 },
  "tc": { "format": null, "maxNationalDigits": 11 },
  "tv": { "format": null, "maxNationalDigits": 12 },
  "vi": { "format": null, "maxNationalDigits": 11 },
  "ug": { "format": null, "maxNationalDigits": 12 },
  "ua": { "format": "+... (..) ... .. ..", "maxNationalDigits": 9 },
  "ae": { "format": null, "maxNationalDigits": 12 },
  "gb": { "format": "+.. .... ......", "maxNationalDigits": 10 },
  "us": { "format": "+. (...) ...-....", "maxNationalDigits": 10 },
  "uy": { "format": null, "maxNationalDigits": 12 },
  "uz": { "format": null, "maxNationalDigits": 12 },
  "vu": { "format": null, "maxNationalDigits": 12 },
  "va": { "format": "+.. .. .... ....", "maxNationalDigits": 10 },
  "ve": { "format": null, "maxNationalDigits": 13 },
  "vn": { "format": null, "maxNationalDigits": 13 },
  "wf": { "format": null, "maxNationalDigits": 12 },
  "ye": { "format": null, "maxNationalDigits": 12 },
  "zm": { "format": null, "maxNationalDigits": 12 },
  "zw": { "format": null, "maxNationalDigits": 12 }
};

export default PHONE_FORMATS_BY_ISO;

